import React from 'react'
import { connect } from 'react-redux'
import Calendar from '../components/calendar'

const mapStateToProps = (state) => ({
  ...state.calendar
})

const mapDispatchToProps = dispatch => ({
  onDateChange: payload => dispatch({type: 'CALENDAR.DATE_CHANGE', payload}),
  onFieldModeChange: payload => dispatch({type: 'CALENDAR.FIELD_MODE_CHANGE', payload}),
  onLocationsUpdate: payload => dispatch({type: 'CALENDAR.LOCATIONS_UPDATE', payload}),
  onEventUpdate: payload => dispatch({type: 'CALENDAR.EVENT_RECEIVED', payload}),
  onRefreshOpenGame: payload => dispatch({type: 'OPEN_GAME_MODAL.REFRESH_GAME', payload}),
  removeGoogleEvents: () => dispatch({type: 'CALENDAR.REMOVE_GOOGLE_EVENTS' }),
  stopSignature: () => dispatch({type: 'SIGNATURE.STOP' }),
  completeSignature: payload => dispatch({type: 'SIGNATURE.COMPLETE', payload }),
  onSendReceipt: payload => dispatch({type: 'SEND_RECEIPT', payload }),
})

export default connect(mapStateToProps, mapDispatchToProps)(Calendar)
